export default {
    review: {
        agreeRB: false
    }
}
